export const getGoalCalculationLabel = ( goalLabel ) => {

    const hasCurrencyOrPercent = [ 'currency', 'percent' ].find( labelType => labelType === goalLabel.labelType );

    if( hasCurrencyOrPercent ) {
        return { ...goalLabel, labelText: '' };
    }else{
        return goalLabel;
    }

};

/*
 * to avoid the instance where we have a "0 per period"
 * label trailing the GoalLabel in the goal row
 */
export const checkPerPeriodValue = ( amount, precision ) => {
    if( amount === 0 && precision === 0 ) {
        return 1;
    }else{
        return amount;
    }
};